module.exports = __webpack_public_path__ + "img/cover1.cf3056bc.png";